const SET_ERROR = 'SET_ERROR'
const CLEAR_ERROR = 'CLEAR_ERROR'

const initialState = {
	error: false,
	error_message: '',
	error_ok_disabled: true,
}

const actions = {
	error_occurred: function({commit, getters, dispatch}, obj) {
		if(obj.error.response && obj.error.response.status && obj.error.response.status === 403) {
			dispatch('auth/logout', {}, {root: true})
		}
		commit(SET_ERROR, obj)
	},

	error_cured: function({commit}) {
		commit(CLEAR_ERROR)
	},
}

const mutations = {
	[SET_ERROR](state, obj) {
		let error_message = null
		if (obj.error.response && obj.error.response.data) {
			if (obj.error.response.data.message) {
				error_message = obj.error.response.data.message
			}
			else {
				if (obj.error.response.data.detail) {
					error_message = obj.error.response.data.detail
				}
				else {
					error_message = "Unknown error key"
				}
			}
		}
		else {
			error_message = obj.error.message
		}
		state.error_message = error_message
		state.error_ok_disabled = obj.ok
		state.error = true
	},

	[CLEAR_ERROR](state) {
		state.error = false
	}
}

export default {
	namespaced: true,
	state: initialState,
	actions,
	mutations,
}